import { combineReducers, configureStore } from "@reduxjs/toolkit";
import resetPasswordReducer from "../reducer/resetPasswordSlice";
import notificationSlice from "../reducer/notificationSlice";
import { persistReducer, persistStore } from "redux-persist";
import searchReducer from '../reducer/initSearchSlice';
import appCarouselSlice from "../reducer/appCarouselSlice";
import authReducer from "../reducer/authSlice";
import storage from "./storage";
import localizationSlice from '../reducer/localizationSlice';

const rootReducer = combineReducers({
  resetPassword: resetPasswordReducer,
  notification: notificationSlice,
  hotelSearch: searchReducer,
  carousel: appCarouselSlice,
  auth: authReducer,
  localization :localizationSlice

});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export { store, persistor };
